import { RouterView } from "vue-router";

export const modulesRoute = {
  path: ":menu/modules",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/modules/list/index.vue"),
    },
    {
      path: ":moduleId/tags",
      component: () => import("@/views/tags/list/index.vue"),
    },
  ],
};
